export const viewerSessionToken = () => window?.objInit?.session_token || null;

export const viewerSessionHeaders = () => {
  const token = viewerSessionToken();
  return token ? { "X-Viewer-Session": token } : {};
};

const withHandoffParams = (url, token, elementId) => {
  try {
    const target = new URL(url);
    target.searchParams.set("kz_via", token);
    target.searchParams.set("kz_el", elementId);
    return target.toString();
  } catch (error) {
    return url;
  }
};

export const openWithK2KHandoff = (url, element) => {
  if (!url || !element?.id || !element?.value?.kdf || !viewerSessionToken()) {
    window.open(url, "_blank");
    return;
  }
  const win = window.open("", "_blank");
  if (!win) return;
  fetch("/viewer/k2k_handoff", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json", ...viewerSessionHeaders() },
    body: JSON.stringify({ element_id: element.id }),
  })
    .then((response) => (response.ok ? response.json() : null))
    .catch(() => null)
    .then((data) => {
      win.location.href = data?.handoff_token ? withHandoffParams(url, data.handoff_token, element.id) : url;
    });
};
